import React from 'react';
import PropTypes from 'prop-types';
import { Container, Title, Message } from './styles';

const DEFAULT_TITLE = 'Scheduled maintenance';
const DEFAULT_MESSAGE = 'System is temporarily unavailable while we perform maintenance. Please check back shortly.';

const renderWithLineBreaks = (text) => text.split('\n').map((line, index, arr) => (
  // eslint-disable-next-line react/no-array-index-key
  <React.Fragment key={index}>
    {line}
    {index < arr.length - 1 && <br />}
  </React.Fragment>
));

const MaintenancePage = ({ title, message }) => (
  <Container role="alertdialog" aria-modal="true" aria-label={title || DEFAULT_TITLE}>
    <Title>{title || DEFAULT_TITLE}</Title>
    <Message>{renderWithLineBreaks(message || DEFAULT_MESSAGE)}</Message>
  </Container>
);

MaintenancePage.propTypes = {
  title: PropTypes.string,
  message: PropTypes.string,
};

export default MaintenancePage;
